import { ICopyInspecaoMaquinaEquipUseCase } from "../../../presentation/useCases/create/copy_inspecao_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CopyInspecaoMaquinaEquipUseCase
 */

export class CopyInspecaoMaquinaEquipUseCase implements ICopyInspecaoMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async copyInspecaoMaquinaEquip(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    nroCopias: number,
  ): Promise<void> {
    await this.repository.copyInspecaoMaquinaEquip(
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      nroCopias,
    );
  }
}
